import { Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { RuleSetResource } from "../../../types";

class RuleSetService {
	public keys = {
		ruleSets: (formId: Id) => ["registration-forms", `${formId}`, "rule-sets"],
		ruleSetsByType: (formId: Id, type: string) => ["registration-forms", `${formId}`, "rule-sets", type],
		ruleSetDetails: (formId: Id, ruleSetId: Id) => ["registration-forms", `${formId}`, "rule-sets", `${ruleSetId}`],
	};

	protected urls = {
		ruleSets: (formId: Id) => keyToUrl(this.keys.ruleSets(formId)),
		ruleSetsByType: (formId: Id, type: string) => keyToUrl(this.keys.ruleSetsByType(formId, type)),
		ruleSetDetails: (formId: Id, ruleSetId: Id) => keyToUrl(this.keys.ruleSetDetails(formId, ruleSetId)),
	};

	getRuleSet = (formId: Id, ruleSetId: Id) =>
		axios.get<LaravelResponse<RuleSetResource[]>>(this.urls.ruleSetDetails(formId, ruleSetId));

	ruleSetsByType = (formId: Id, ruleSetType: string) =>
		axios.get<LaravelResponse<RuleSetResource[]>>(this.urls.ruleSetsByType(formId, ruleSetType));
}

export const ruleSetService = new RuleSetService();
